import { lazy } from 'react'
import serverData from '../utils/server-data'

const PasswordRecoveryHomeScreen = lazy(() =>
  import('../modals/dataPrivacy/password-recovery/HomeScreen'),
)
const Verification = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/verification'),
)

const LoggedOutConfirmEmail = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/ConfirmYourEmail'),
)
const LoggedOutDsrForm = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/LoggedOutDsrForm'),
)
const LoggedOutWelcome = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/introduction'),
)
const Status = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/status'),
)
const LoggedOutTrackYourData = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/TrackYourRequest'),
)

const { closeUrl = null, backUrl = null } = serverData

export default {
  '/common/pypl': {
    props: {
      slides: [LoggedOutWelcome, LoggedOutDsrForm, LoggedOutConfirmEmail],
      backUrl,
      closeUrl,
      domid: 'logged_out_modal',
    },
  },
  '/common/pypl/trackrequest': {
    props: {
      slides: [LoggedOutTrackYourData, Status],
      backUrl,
      closeUrl,
      domid: 'data_track_modal',
    },
  },
  '/common/pypl/verification': {
    props: {
      backUrl,
      closeUrl,
      domid: 'data_verify_modal',
      slides: [Verification],
    },
  },
  '/common/password-recovery': {
    props: {
      showBackButton: false,
      backUrl: '',
      closeUrl: '',
      domid: 'password_recovery_modal',
      slides: [PasswordRecoveryHomeScreen],
    },
  },
  // Use this screen mapper to load the full page modal window
}
